<div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW') && shipInstallations.length == 0">
  <div class="card-heading">
    <i class="fa fa-history"></i>
    <span class="cardHeaderHeading"> Roundtrip History </span>
  </div>
  <div class="card-body" *ngIf="shipRoundTripHistory">
    <table class="table table-striped table-bordered">
      <thead class="tableheading">
        <tr>
          <th class="text-center transactionHistHeader">BATCH ID</th>
          <th class="text-center transactionHistHeader">START TIME</th>
          <th class="text-center transactionHistHeader">END TIME</th>
          <th class="text-center transactionHistHeader">EOD</th>
          <th class="text-center transactionHistHeader">LEDGER</th>
          <th class="text-center transactionHistHeader">EOP</th>
          <th
            class="text-center transactionHistHeader"
            *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_REPORTS_LINK')"
          >
            REPORTS
          </th>
          <th class="text-center transactionHistHeader">STATUS</th>
        </tr>
      </thead>
      <tbody style="background-color: #ffffff;">
        <tr *ngIf="shipRoundTripHistory.lastRoundTrips.length == 0">
          <td
            align="center"
            colspan="hasEntitlements('SHIPS_ROUNDTRIPS_REPORTS_LINK')? 8 : 7"
            style="height: 150px;"
          >
            No history found.
          </td>
        </tr>
        <tr
          *ngFor="
            let lastRoundtripDetail of shipRoundTripHistory.lastRoundTrips
          "
        >
          <td class="text-center transactionHistText">
            {{ lastRoundtripDetail.batchId }}
          </td>
          <td class="text-center transactionHistText">
            {{ lastRoundtripDetail.startTime | date: 'MM/dd/yyyy hh:mm:ss' }}
          </td>
          <td class="text-center transactionHistText">
            {{ lastRoundtripDetail.endTime | date: 'MM/dd/yyyy hh:mm:ss' }}
          </td>
          <td class="text-center transactionHistText">
            {{ lastRoundtripDetail.isEndOfDayBatch | yesNo }}
          </td>
          <td class="text-center">
            <div
              [ngClass]="{
                transactionHistPos: lastRoundtripDetail.totLedgerBal >= 0,
                bulkOrderStatusRed: lastRoundtripDetail.totLedgerBal < 0
              }"
            >
              ${{ lastRoundtripDetail.totLedgerBal }}
            </div>
          </td>

          <td class="text-center transactionHistText">
            {{ lastRoundtripDetail.endOfPeriod }}
          </td>
          <td
            class="text-center"
            *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_REPORTS_LINK')"
          >
            <div *ngIf="lastRoundtripDetail.isEndOfDayBatch === 1">
              <a (click)="gotoShipReports(lastRoundtripDetail.batchId)">
                <i class="fa fa-file-text-o" style="color: grey"></i>
              </a>
            </div>
          </td>
          <td class="text-center">
            <i
              [ngClass]="
                lastRoundtripDetail.processingStatus | processingStatusPipe
              "
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
